require('./cardTransferMoneyToCheckingAccountFeedbackError.scss');

// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');

// @utilities
const { formatText } = require('core/i18n').i18n;

// @components
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');

class CardTransferMoneyToCheckingAccountFeedbackError extends React.Component {
    constructor(props) {
        super(props);
        this.backToCards = this.backToCards.bind(this);
    }

    backToCards() {
        this.props.history.push('/myprofile/cards');
    }

    render() {
        const title = formatText('cardTransferMoneyToCheckingAccountFeedbackError-title');
        const subtitle = formatText('cardTransferMoneyToCheckingAccountFeedbackError-subtitle');
        const textLink = formatText('cardTransferMoneyToCheckingAccountFeedbackError-backToCards');

        return (
            <div className="card-transfer-money-to-checking-account-feedback-error">
                <CustomMessageBox
                    icon="icon-warning"
                    title={title}
                    subtitle={subtitle}
                    textLink={textLink}
                    goBackHandler={this.backToCards}
                />
            </div>
        );
    }
}

CardTransferMoneyToCheckingAccountFeedbackError.propTypes = {
    history: PropTypes.object.isRequired,
}

module.exports = withRouter(CardTransferMoneyToCheckingAccountFeedbackError);
